import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Shared} from "../../../shared/shared";
import {CourseService} from "../../../../service/CourseService";
import {BooleanComponent} from "../../generic/table/booleanComponent/booleanComponent";
import {CalendarComponent} from "../../generic/table/calendarComponent/calendarComponent";
import {TextComponent} from "../../generic/table/textComponent/textComponent";
import {DropdownComponent} from "../../generic/table/dropdownComponent/dropdownComponent";
import {ModalityEntity} from "../../../../model/ModalityEntity";
import {CourseTypeEntity} from "../../../../model/CourseTypeEntity";
import {CourseEntity} from "../../../../model/CourseEntity";
import {ButtonComponent} from "../../generic/table/buttonComponent/buttonComponent";
import {SiteEntity} from "../../../../model/SiteEntity";
import * as moment from 'moment-timezone';
import {BasicDto} from "../../../../dto/BasicDto";
import {ContextService} from "../../../../service/ContextService";
import {CourseFrontPageEntity} from "../../../../model/CourseFrontPageEntity";
import {TurnEntity} from "../../../../model/TurnEntity";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {PermissionRoleEntity} from "../../../../model/PermissionRoleEntity";
import {CommonCourseDto} from "../../../../dto/CommonCourseDto";
import {StaticCalendarEntity} from "../../../../model/StaticCalendarEntity";

@Component({
  selector: 'app-modality',
  templateUrl: 'modality.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class Modality {

  @Input() modalities: ModalityEntity[];
  @Input() coursesType: CourseTypeEntity[];
  @Input() courses: CourseEntity[];
  @Input() commonCourse: CommonCourseDto;

  @Output() filter = new EventEmitter<number>();

  aux: CourseTypeEntity[];
  roles: BasicDto[];
  staticCalendars: StaticCalendarEntity[];
  staticCalendarsFiltered: StaticCalendarEntity[];

  newEntity: ModalityEntity;
  modeAdd = false;

  showStartDate = false;
  showEndDate = false;
  showOpenSignupDate = false;
  showCloseSignupDate = false;
  showSettings = false;
  showCustomize = false;

  currentModality: ModalityEntity;
  currentCourseFrontPage: CourseFrontPageEntity;

  availableParents: any = [];
  permissionSettings = false;

  parentId: number;
  parentType: string;
  currentParentRole: number;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: true,
    placeholder: 'Enter text here...',
    fonts: [
      {class: 'arial', name: 'Arial'},
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['indent', 'outdent', 'superscript', 'subscript', 'link', 'unlink', 'insertImage', 'insertVideo', 'strikeThrough', 'fontName'],
    ]
  };

  headers: any = {
    columns: {
      alias: {title: 'Alias', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: TextComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeText.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.alias = data.text;
              this.saveModality(modality, false);
            });
          }
        },
      },
      name: {title: 'Name', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: TextComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeText.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.name = data.text;
              this.saveModality(modality, false);
            });
          }
        },
      },
      courseTypeId: {title: 'Course type', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => { return {cell: cell, options: this.aux}},
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.courseTypeId = data.id;
              this.saveModality(modality, false);
            });
          }
        },
      },
      startDate: {
        title: 'Start date', hide: false, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.startDate = data.date;
              this.saveModality(modality, false);
            });
          }
        },
      },
      endDate: {
        title: 'End date', hide: false, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.endDate = data.date;
              this.saveModality(modality, false);
            });
          }
        },
      },
      openSignupDate: {
        title: 'Open signup date', hide: true, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.openSignupDate = data.date;
              this.saveModality(modality, false);
            });
          }
        },
      },
      closeSignupDate: {
        title: 'Close signup date', hide: true, filter: true, editable: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: CalendarComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeCalendar.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.closeSignupDate = data.date;
              this.saveModality(modality, false);
            });
          }
        },
      },
      defaultRole: {
        title: 'Default role', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: cell, options: this.roles}
        },
        renderComponent: DropdownComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeDropdown.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.defaultRole = data.id;
              this.saveModality(modality, false);
            });
          }
        },
      },
      contentNotification: {
        title: 'Content notification', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.contentNotification = data.bool;
              this.saveModality(modality, false);
            });
          }
        },
      },
      showInRegister: {
        title: 'Show in Register', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.showInRegister = data.bool;
              this.saveModality(modality, false);
            });
          }
        },
      },
      showInCampus: {
        title: 'Show in Campus', hide: false, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.showInCampus = data.bool;
              this.saveModality(modality, false);
            });
          }
        },
      },
      showInMagnament: {
        title: 'Show in Magnament', hide: true, filter: true, type: "custom",
        valuePrepareFunction: (cell, row) => cell,
        renderComponent: BooleanComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeBool.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data.row.id)
              modality.showInMagnament = data.bool;
              this.saveModality(modality, false);
            });
          }
        },
      },
      id: {title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: cell, icon: 'arrow-redo-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.nextStep(data);
            });
          }
        },
      },
      corpId: {
        title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'brush-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.customizeCourse(data);
              this.showCustomize=true;
            });
          }
        },
      },
      row2: {title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'copy-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.cloneModality(data);
            });
          }
        },
      },
      row3: {title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'settings-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              this.openSettingsDiv(data);
              this.showSettings=true;
            });
          }
        },
      },
      row4: {
        title: '', hide: false, filter: false, type: "custom",
        valuePrepareFunction: (cell, row) => {
          return {cell: row.id, icon: 'shield-outline', text: '', color: ''}
        },
        renderComponent: ButtonComponent,
        onComponentInitFunction: (instance) => {
          if (instance != null) {
            instance.changeButton.subscribe(data => {
              let modality = this.modalities.find(x => x.id == data);
              this.parentType = 'MODALITY';
              this.parentId = modality.id;
              this.currentParentRole = modality.defaultRole;
              this.permissionSettings = true;
            });
          }
        },
      },
    },
    actions: false,
  }

  constructor(private courseService: CourseService, private contextService: ContextService, private shared: Shared) {
  }

  ngOnInit() {
    this.aux = JSON.parse(JSON.stringify(this.coursesType.map(x=> {
      x.name = x.name+" ("+this.courses.find(y=> y.id == x.courseId).alias+")";
      return x;
    })
    ));
    this.roles = this.commonCourse.roles;
    this.staticCalendars = this.commonCourse.staticCalendars;
    this.staticCalendars.forEach(item => {
      item.alias = item.name;
    });
  }

  customizeCourse(id: number) {
    this.currentModality = this.modalities.find(x => x.id == id);
    this.currentCourseFrontPage = new CourseFrontPageEntity();
    this.currentCourseFrontPage.corpId = this.shared.CORP_ID;
    this.currentCourseFrontPage.modalityId = id;
    this.currentCourseFrontPage.html = "";
    this.currentCourseFrontPage.backgroundImage = "";
    this.currentCourseFrontPage.enabled = true;
    this.courseService.getCourseFrontPageByModality(this.currentModality.id).subscribe(t => {
      if (t != null) {
        this.currentCourseFrontPage = t;
      }
    });
  }

  openSettingsDiv(courseTypeId){
    this.currentModality = this.modalities.find(p=> p.id == courseTypeId);
    let ct = this.coursesType.find(p=> p.id == this.currentModality.courseTypeId);
    let c = this.courses.find(p=> p.id == ct.courseId);

    this.staticCalendarsFiltered = this.staticCalendars.filter(x => x.courseId == c.id || x.courseId == null);

    this.availableParents.push({'id':c.id, 'name':c.name, 'type': "COURSE"});
    this.coursesType.filter(t=>t.courseId == c.id).forEach(ct=>{
        this.availableParents.push({'id': ct.id, 'name': "--"+ct.name, 'type': "COURSE_TYPE"});
        this.modalities.filter(r=> r.courseTypeId == ct.id).forEach(m=>{
          this.availableParents.push({'id': m.id, 'name': "-- -- "+m.name, 'type': "MODALITY"});
        })
    })
  }

  saveCourseFrontPage() {
    this.courseService.saveCourseFrontPage(this.currentCourseFrontPage).subscribe(t => {
      if (t != null) {
        this.currentCourseFrontPage = t;
      }
    });
    this.currentModality = null;
    this.showCustomize=false;
  }


  cloneModality(id){
    let bool = confirm("¿Estás seguro que deseas duplicar el modalidad?");

    if(bool) {
      this.courseService.cloneModality(id).subscribe((w: ModalityEntity[]) => {
        if (w != null) {
          this.modalities = w;
        }
      });
    }
  }

  nextStep(id: number){
    this.filter.emit(id);
  }

  saveModality(modality: ModalityEntity, bool) {
    if(modality.name.indexOf('(')!=-1) {
      modality.name = modality.name.substr(0,modality.name.indexOf('('));
    }
    this.courseService.saveModality(modality).subscribe( t =>{
      if(t!=null) {
        if(bool){this.modalities.push(t);}
        this.modalities = this.modalities.filter(x => {return x});
      }
    });
  }

  async saveNewModality() {
    this.saveModality(this.newEntity, true);
    this.modeAdd = false;
  }

  newModality(){
    this.modeAdd = true;
    this.newEntity = new ModalityEntity();
    this.newEntity.corpId = this.shared.CORP_ID;
    this.newEntity.showInMagnament = true;
  }

  changeStartDate(event){
    this.newEntity.startDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeEndDate(event){
    this.newEntity.endDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeOpenSingupDate(event){
    this.newEntity.openSignupDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  changeCloseSingupDate(event){
    this.newEntity.closeSignupDate = moment(event.value).format('yyyy-MM-DDTHH:mm:ss');
  }

  convertFileToBase64DocumentB(evt) {
    let me = this;
    let file = evt.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      me.currentCourseFrontPage.backgroundImage = reader.result.toString();
    };
  }

  convertFileToBase64DocumentS(evt) {
    let me = this;
    let file = evt.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      me.currentCourseFrontPage.subscriptionImage = reader.result.toString();
    };
  }

  async closePermissionsWindow(data: PermissionRoleEntity[]){
    this.permissionSettings = false;
    this.roles = null;
    await this.delay(200);
    this.roles = data.map(d=> new BasicDto(d.id, d.alias, d.name, null));
  }

  splitByComma(text) {
    if (text != null) {
      return text.split(',');
    }
    return null;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
